<template>
  <section v-lenis-scroll class="thar-left-collection-sec">
    <div class="tharLeftCollection">
      <div class="tharPrefall">
        <div class="tharLeftSide">
          <img
            class="tharLeftImage"
            :src="shopifyData.leftTextImage"
            alt="Text Image"
            loading="lazy"
            aria-hidden="true"
            aria-label="Text Image"
            width=""
            height=""
          />
        </div>
        <div class="tharRightInfo">
          <img
            class="tharRightText1"
            :src="shopifyData.rightTopImage"
            alt="Right Top Image"
            loading="lazy"
            aria-hidden="true"
            aria-label="Right Top Image"
            width=""
            height=""
          />
          <img
            class="tharRightImage"
            :src="shopifyData.rightMiddleImage"
            alt="Right Middle Image"
            loading="lazy"
            aria-hidden="true"
            aria-label="Right Middle Image"
            width=""
            height=""
          />
          <img
            class="tharRightText3"
            :src="shopifyData.rightBottomImage"
            alt="Right Bottom Image"
            loading="lazy"
            aria-hidden="true"
            aria-label="Right Bottom Image"
            width=""
            height=""
          />
        </div>
      </div>

      <div class="tharRightSide">
        <div class="responsiveImage">
          <img
            :src="shopifyData.leftTextImage"
            alt="Text Image"
            loading="lazy"
            aria-hidden="true"
            aria-label="Text Image"
            width=""
            height=""
          />
        </div>
        <div class="tharProducts">
          <div v-for="(value, key) in shopifyData.productData" :key="key" class="grid_item">
            <a
              v-if="value.showCollection == 'true'"
              :href="value.collectionLink"
              class="product_link"
            >
              <div
                class="tharProductInfo"
                :class="value.showPreview === 'true' ? 'customImage' : ''"
              >
                <h2 class="tharProductTitle">{{ value.product.productTitle }}</h2>
                <div class="tharProductPriceInfo">
                  <span
                    v-if="value.product.compare_at_price > value.product.productidPrice"
                    class="tharProductPrice"
                  >
                    <del>
                      {{ currencySymbol }}
                      {{ value.product.compare_at_price }}
                    </del>
                  </span>
                  <span v-if="value.product.productidPrice" class="tharProductPrice">
                    {{ currencySymbol }}
                    {{ value.product.productidPrice }}
                  </span>
                  <span
                    v-if="value.product.compare_at_price > value.product.productidPrice"
                    class="discountPercentage tharProductPrice"
                  >
                    {{ value.product.discount_percentage }}
                  </span>
                </div>
              </div>
              <div class="grid_item_img">
                <img
                  v-lazy="
                    value.showPreview == 'true' ? value.previewimage : value.product.productidImage
                  "
                  :alt="value.showPreview === 'true' ? 'Preview Image' : 'Product Image'"
                  loading="lazy"
                  aria-hidden="true"
                  aria-label="Product Image"
                  width=""
                  height=""
                />
              </div>
            </a>

            <a
              v-else
              :href="value.product.productUrl"
              :product-id="value.product.productid"
              class="product_link"
            >
              <div
                class="tharProductInfo"
                :class="value.showPreview === 'true' ? 'customImage' : ''"
              >
                <h2 class="tharProductTitle">{{ value.product.productTitle }}</h2>
                <div class="tharProductPriceInfo">
                  <span v-if="value.product.compare_at_price > '1'" class="tharProductPrice">
                    <del>
                      {{ currencySymbol }}
                      {{ value.product.compare_at_price }}
                    </del>
                  </span>
                  <span v-if="value.product.productidPrice" class="tharProductPrice">
                    {{ currencySymbol }}
                    {{ value.product.productidPrice }}
                  </span>
                  <span
                    v-if="value.product.compare_at_price > '1'"
                    class="discountPercentage tharProductPrice"
                  >
                    {{ value.product.discount_percentage }}
                  </span>
                </div>
              </div>
              <div class="grid_item_img">
                <img
                  v-lazy="
                    value.showPreview == 'true' ? value.previewimage : value.product.productidImage
                  "
                  :alt="value.showPreview === 'true' ? 'Preview Image' : 'Product Image'"
                  loading="lazy"
                  aria-hidden="true"
                  aria-label="Product Image"
                  width=""
                  height=""
                />
              </div>
            </a>
          </div>
        </div>
        <div class="space" />
      </div>
    </div>
  </section>
</template>

<script>
import { currencyJson } from '@/currency';
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currencySymbol: currencyJson[window?.Shopify?.currency?.active]?.symbol_native,
    };
  },
  mounted() {
    this.currencySymbol = currencyJson[window?.Shopify?.currency?.active]?.symbol_native;
  },
};
</script>

<style scoped>
.tharProductTitle,
.tharProductPrice {
  font-family: 'Helvetica Neue', sans-serif;
  font-size: 12.08px;
  font-weight: 400;
  line-height: 10.99px;
  letter-spacing: 0.01em;
  text-align: left;
  color: #000;
}

.tharProductPriceInfo {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
}

.discountPercentage {
  color: red;
}

.tharProductPrice {
  font-weight: 700;
}

.tharProductInfo.customImage * {
  color: #ffff;
}

.tharProductInfo.customImage .discountPercentage {
  color: red;
}

.tharProductInfo.customImage .tharProductPrice del {
  color: grey;
}

.grid_item_img img {
  display: block;
}

.tharPrefall {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  height: 100vh;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.tharRightSide {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  position: relative;
  z-index: 4;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

.tharRightInfo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 71px 20px 81px 20px;
  align-items: center;
  position: relative;
  z-index: 1;
}

.tharLeftImage {
  max-width: 773px;
  width: 100%;
  position: relative;
  z-index: 1;
  /* Ensure stacking order */
}

.tharRightText1 {
  max-width: 452px;
  width: 100%;
  padding-bottom: 47px;
}

.tharRightText3 {
  max-width: 371px;
  width: 100%;
  padding-top: 55px;
}

.tharRightImage {
  max-width: 255px;
  width: 100%;
  position: relative;
  z-index: 1;
}

.tharLeftSide {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  z-index: 1;
}

.tharProducts {
  display: grid;
  grid-template-columns: 50% 50%;
  position: relative;
  z-index: 9;
  background-color: #eeeff2;
}

.tharProducts img {
  width: 100%;
}

.tharProducts .grid_item {
  position: relative;
}

.grid_item .tharProductInfo {
  position: absolute;
  bottom: 12px;
  left: 10px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.responsiveImage {
  display: none;
}

@media screen and (max-width: 768px) {
  .tharPrefall {
    grid-template-columns: 1fr;
    position: static;
    height: auto;
    padding-top: 60px;
  }

  .space {
    display: none;
  }

  .tharRightSide {
    grid-template-columns: 1fr;
  }

  .tharLeftImage {
    display: none;
  }

  .responsiveImage {
    display: block;
    padding: 45px 0;
    background-color: #fff;
    position: relative;
    z-index: 9;
    text-align: center;
  }

  .responsiveImage img {
    text-align: center;
    max-width: 377px;
    width: 100%;
  }

  .tharLeftSide {
    display: none;
  }

  .tharRightInfo {
    padding: 0 53px;
  }

  .tharProductTitle,
  .tharProductPrice {
    font-size: 8px;
    line-height: 1;
    letter-spacing: 0.01em;
  }

  .grid_item .tharProductInfo {
    bottom: 2px;
    left: 2px;
    padding: 5px;
  }
}
</style>
